import React, { Component } from 'react';
import SideMenu from '../SideMenu/SideMenu';
import { DataTable } from '../DataTable/DataTable';
import { connect } from 'react-redux';
import DeviceSearchComponent from './DeviceSearch';
import { actions } from '../../helpers/messages';
import { Link } from 'react-router-dom';
import { convertUTCToLocalDateTime, getDeviceTypeName } from '../../helpers/GlobalFunctions';

class DeviceListComponent extends Component {
    render() {
        const { loading, searchString, searchSubmit, refreshDeviceList, handleSearchSubmit, handleReset, location } = this.props;
        /* istanbul ignore next  */
        const columns = [
            {
                Header: 'Device Serial No.',
                accessor: 'serialnumber',
                Cell: ({ row }) => (<span>{row.original.serialnumber}</span>),
                Filter: ''
            },
            {
                Header: 'Type',
                accessor: 'devicetype',
                Cell: ({ row }) => (<span>{row?.original?.devicetype ? getDeviceTypeName(row.original.devicetype) : 'N/A'}</span>),
                disableSortBy: true,
                Filter: ''
            },
            {
                Header: 'Source',
                accessor: 'location',
                Cell: ({ row }) => (<span>{row?.original?.location?.toUpperCase() || 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: 'Created Date',
                accessor: 'createddate',
                Cell: ({ row }) => (<span>{row.original.createddate ? convertUTCToLocalDateTime(row.original.createddate) : 'N/A'}</span>),
                Filter: ''
            },
            {
                Header: '',
                accessor: 'action',
                Cell: ({ row }) => (<div >
                    <Link className="text-dark" title="View Details" to={{ pathname: "/device-details", state: { deviceId: row.original.serialnumber } }} >
                        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-eye cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                            <path fillRule="evenodd" d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z" />
                            <path fillRule="evenodd" d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                        </svg>
                    </Link>
                </div>),
                disableSortBy: true,
                Filter: ''
            }

        ];
        return (
            <div>
                {loading ? <div className="loading-overlay"><span>{actions.load}</span></div> : null}
                <div className="bgGray">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-1">
                                <SideMenu />
                            </div>
                            <div className="col-md-11">
                                <div className="surgeon-list data-list-tabs table-wrap px-3" data-testid="deviceList">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h1 className="file-list-heading">CORI-XT Devices</h1>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <DeviceSearchComponent handleSearchSubmit={handleSearchSubmit} handleReset={handleReset} />
                                        </div>
                                    </div>
                                    <div className="device-list-container">
                                        <DataTable
                                            listType="device-list"
                                            showPagination={true}
                                            columns={columns}
                                            searchString={searchString && searchSubmit ? searchString : ''}
                                            location={location}
                                            refreshDataList={searchSubmit || refreshDeviceList}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => (
    {
        state
    }
)
const mapDispatchToProps = (dispatch) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceListComponent);
